module.exports = __webpack_public_path__ + "static/img/exp2.2f34f898.png";